var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MembershipUpdate',{attrs:{"userID":_vm.userId,"userName":_vm.userName}})}
var staticRenderFns = []

export { render, staticRenderFns }